(() => {
  // Shopify injects exit-interstitial.js ("Are you sure you want to leave …?") for hosts outside its
  // allowlist. It skips clicks whose default action is already prevented, so we open these hosts ourselves.
  const DIRECT_HOSTS = ['wa.me', 'whatsapp.com'];

  const isDirectHost = (hostname) =>
    DIRECT_HOSTS.some((host) => hostname === host || hostname.endsWith(`.${host}`));

  const handle = (event) => {
    if (event.defaultPrevented) return;
    if (event.type === 'auxclick' && event.button !== 1) return;

    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;

    let url;
    try {
      url = new URL(link.href);
    } catch (error) {
      return;
    }
    if (!/^https?:$/.test(url.protocol) || !isDirectHost(url.hostname)) return;

    event.preventDefault();
    window.open(url.href, '_blank', 'noopener');
  };

  document.addEventListener('click', handle);
  document.addEventListener('auxclick', handle);
})();
